import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import IconButton from '@mui/material/IconButton';

import { showSidebarMenu } from '../../../redux/modules/header';
import SidebarMenu from '../../../components/Header/SidebarMenu';
import { VpIcon } from '../..';
import VpHeaderLogo from '../VpHeaderLogo/VpHeaderLogo';
import { StyledMobileNav } from './styles';

export const Hamburger = ({ _showSidebarMenu }) => {
  return (
    <StyledMobileNav>
      <VpHeaderLogo />
      <IconButton onClick={_showSidebarMenu}>
        <VpIcon icon="Menu" />
      </IconButton>
      <SidebarMenu />
    </StyledMobileNav>
  );
};

Hamburger.propTypes = {
  _showSidebarMenu: PropTypes.func
};

const mapDispatchToProps = {
  _showSidebarMenu: showSidebarMenu
};

export default connect(null, mapDispatchToProps)(Hamburger);



// WEBPACK FOOTER //
// ./src/vp-ui/components/HamburgerMenu/Hamburger.jsx